import React, { useEffect, useState } from "react";
import TransactionCard from "./transactionCard";
import TransactionIcon from "../constants/assests/image/TransactionIcon.png";
import Header from "../shared/header";
import EmptyData from "../shared/emptyData";
import LoadingIndicator from "../shared/loadingIndicator";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const Transaction: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchCustomerHistory(currentPage);
  }, [currentPage]);

  const fetchCustomerHistory = async (page: number) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const apiUrl = process.env.REACT_APP_API_URL;
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await fetch(
        `${apiUrl}${shop_domain}/api/v1/customer/history?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      setData(result.data.data);
      setTotalPages(result.data.last_page);
    } catch (error) {
      console.error("Error fetching customer history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const getFooterTextColor = (type: string) => {
    return type === "earned" ? "green" : "red";
  };

  const getPlusMin = (type: string) => {
    return type === "earned" ? "+" : "-";
  };

  return (
    <div className="flex flex-col w-full h-screen bg-bright-ashe">
      <div className="fixed top-0 z-10">
        <a href="/homePage">
          <Header icon={<KeyboardArrowLeftIcon />} name="Point History" />
        </a>
      </div>

      <div className="flex flex-col w-full p-5 mt-12 pb-20 bg-bright-ashe">
        {loading ? (
          <LoadingIndicator />
        ) : data.length > 0 ? (
          data.map((coupon) => (
            <div key={coupon.id}>
              <TransactionCard
                header={coupon.title}
                src={TransactionIcon}
                description={coupon.created_at}
                footerText={coupon.points}
                color={getFooterTextColor(coupon.type)}
                plusMin={getPlusMin(coupon.type)}
                type={coupon.type}
                reference_type={coupon.reference_type}
                is_points_updated={coupon.is_points_updated}
              />
            </div>
          ))
        ) : (
          <EmptyData />
        )}
      </div>

      <div className="flex justify-center py-3 fixed bottom-0 bg-white w-full border-t border-gray-200">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="text-slate-600 font-thin px-4"
        >
          <KeyboardArrowLeftIcon />
        </button>
        <span className="text-sm font-semibold pt-1">Page {currentPage}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="text-slate-600 font-thin px-4"
        >
          <KeyboardArrowRightIcon />
        </button>
      </div>
    </div>
  );
};

export default Transaction;
